import * as KnownSocialPlatform from './known-social-platform'

import type { SocialsDto, SocialsEditDto } from '@root/shared/api/ServicesApi'

export type TgInfo = {
  portalLink: string
  name: string
  members: number
}

type TwitterProfileUserDto = Extract<
  NonNullable<SocialsDto['twitterInfo']>,
  { type: 'profile' }
>['user']

export type TwitterSocialProfileStats =
  | 'favouritesCount'
  | 'followersCount'
  | 'followingCount'
  | 'mediaCount'

export interface Socials {
  x: string | KnownSocialPlatform.XKnownSocialPlatform | undefined
  discord: string | undefined
  website: string | undefined
  knownPlatform: KnownSocialPlatform.KnownSocialPlatform | undefined
  telegram: string | Array<TgInfo> | undefined
  twitterInfo?: {
    type: 'profile'
    user: TwitterProfileUserDto & { pastHandles?: Array<string> }
  }
}

export const getXString = (x: NonNullable<Socials['x']>) => {
  return typeof x === 'string' ? x : x.url
}

export type TwitterSocialProfile = NonNullable<Socials['twitterInfo']>['user']

export const empty = (): Socials => ({
  x: undefined,
  discord: undefined,
  website: undefined,
  knownPlatform: undefined,
  telegram: undefined,
})

export const fromDto = (dto: SocialsDto): Socials => {
  const { twitterInfo: info } = dto

  const xRaw = Array.isArray(dto.twitter) ? dto.twitter[0] : dto.twitter

  const x = xRaw ? (KnownSocialPlatform.xFromString(xRaw) ?? xRaw) : undefined

  return {
    ...empty(),
    x,
    discord: dto.discord,
    website: dto.website,
    knownPlatform: dto.website
      ? KnownSocialPlatform.fromString(dto.website)
      : undefined,
    telegram: dto.telegram,
    twitterInfo:
      info?.type === 'profile'
        ? {
            type: 'profile',
            user: {
              ...info.user,
              pastHandles: undefined,
            },
          }
        : undefined,
  }
}

export const toDto = (socials: Socials): SocialsEditDto => {
  return {
    twitter: socials.x ? getXString(socials.x) : undefined,
    discord: socials.discord,
    website: socials.website,
    telegram:
      typeof socials.telegram === 'string' ? socials.telegram : undefined,
  }
}

export const hasAtLeastOneSocial = (socials: Socials): boolean => {
  return (
    socials.x !== undefined ||
    socials.discord !== undefined ||
    socials.website !== undefined ||
    socials.telegram !== undefined
  )
}
